<script setup>
import Cookies from "js-cookie";
import {ElNotification} from "element-plus";
import {onMounted, ref} from "vue";
onMounted(async ()=>{
  await getData()
})
const Data = ref(null)
async function getData(newpage){
  const response = await fetch('https://inv.tvcnews.co/endPoint/getProjects3.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '
    },
    body:JSON.stringify({page:1})
  })
  const data = await response.json();
  console.log(data)
  switch (data.status){
    case 200:
      Data.value= data?.data
      break;
    default:
      ElNotification({
        title: 'Error '+data.status,
        message: data.message,
        type: 'error'
      })
      // router.push('/')
      break;
  }
}
</script>
<template>
  <div class="card card-carousel overflow-hidden h-100 p-0">
    <div id="carouselExampleCaptions" class="carousel slide h-100" data-bs-ride="carousel">
      <div class="carousel-inner border-radius-lg h-100">
        <div
            class="carousel-item h-100 active"
            v-for="(item, index) in Data"
            :key="index"
            :style="{
    backgroundImage: 'url('+item?.Medias[0]?.Url+')',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative'
  }"
        >
          <!-- Overlay for opacity -->
          <div
              class="background-overlay"
              :style="{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', /* Adjust opacity as needed */
      zIndex: 1
    }"
          ></div>

          <!-- Content inside the carousel item -->
          <div
              class="carousel-caption d-none d-md-block bottom-0 text-start start-0 ms-5"
              style="text-align: right; position: relative; zIndex: 2;margin: 50px 20px 0 0"
          >
            <h5 class="text-white mb-1" style="font-family: Tahoma; text-align: right;">
              {{item?.ProjectName}}
            </h5>
            <p style="font-family: Tahoma; direction: rtl; text-align: right;">
              {{item?.Description}}
            </p>
          </div>
        </div>

      </div>
      <button
        class="carousel-control-prev w-5 me-3"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next w-5 me-3"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>
